module.exports = __webpack_public_path__ + "img/times-solid.5ed09c7e.svg";